const initialState = {
  account: {},
  timeWindows: [],
  timeWindowsAvailability: {},
  trackingSetting: {},
};

function account(state = initialState, action) {
  switch (action.type) {
    case 'RECEIVE_ACCOUNT':
      return {
        ...state,
        account: action.account,
      };
    case 'RECEIVE_TRACKING_SETTING':
      return {
        ...state,
        trackingSetting: action.trackingSetting,
      };
    case 'RECEIVE_TIME_WINDOWS':
      return {
        ...state,
        timeWindows: action.timeWindows,
      };
    case 'RECEIVE_TIME_WINDOWS_AVAILABILITY': {
      // Availability is in the format:
      //   Array of { date: <>, data: [{ time_window_id, availability }, ...] } object
      // Convert to Object with dates as key for easier access and update

      const updatedTimeWindowsAvailability = { ...state.timeWindowsAvailability };
      action.timeWindowsAvailability.forEach((twAvailability) => {
        updatedTimeWindowsAvailability[twAvailability.date] = twAvailability.data;
      });

      return {
        ...state,
        timeWindowsAvailability: updatedTimeWindowsAvailability,
      };
    }
    default:
      return state;
  }
}

export default account;
